export default __webpack_public_path__ + "static/media/3.73f595c0.png";